import React, { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export const useCaptcha = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = React.useCallback(async () => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      return;
    }
    const token = await executeRecaptcha("apptracker");
    // Do whatever you want with the token
    setCaptchaToken(token);
    return token;
  }, [executeRecaptcha]);

  // You can use useEffect to trigger the verification as soon as the component being loaded
  React.useEffect(() => {
    if(!captchaToken)
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify, captchaToken]);
  
  return {captchaToken, handleReCaptchaVerify}
};
